import { useState, useRef, useEffect } from "react";
import { observer } from "mobx-react";
import { QuestionsReportModal } from "../QuestionsReportModal/QuestionsReportModal";
import { AnswerReportModal } from "../AnswerReportModal/AnswerReportModal";

import "./ExpandableAnswer.scss";

const COLLAPSE_HEIGHT = 250;

export const ExpandableAnswer = observer(({ reportData, isOpen }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [needsTruncation, setNeedsTruncation] = useState(false);
  const wrapperRef = useRef(null);
  const hasQuestions = Boolean(reportData.questions);

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return;

    const check = () => {
      setNeedsTruncation(el.scrollHeight > COLLAPSE_HEIGHT);
    };

    check();

    const observer = new ResizeObserver(check);
    observer.observe(el);

    return () => observer.disconnect();
  }, [reportData]);

  useEffect(() => {
    if (!isOpen) {
      setIsExpanded(false);
    }
  }, [isOpen]);

  return (
    <div
      className={`report-modal__info-answer${reportData.autoApproved ? " autoapproved" : ""}${!hasQuestions ? " report-modal__info-answer-full" : ""}`}
    >
      <div
        ref={wrapperRef}
        className={[
          "report-modal__info-answer-inner",
          !hasQuestions && "report-modal__info-answer-inner-no-questions",
          needsTruncation &&
            !isExpanded &&
            "report-modal__info-answer-inner-collapsed",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {hasQuestions && <QuestionsReportModal report={reportData} />}
        <AnswerReportModal report={reportData} />
      </div>

      {needsTruncation && (
        <button
          className="report-modal__show-more"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          {isExpanded ? "Скрыть" : "Показать ещё"}
        </button>
      )}
    </div>
  );
});
